import styled from 'styled-components';
import { Table } from 'antd';

const ROW_SEPARATOR_COLOR = '#F0F2F5';

export const Subtitle = styled.h4`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.25rem;
	font-weight: 600;
	line-height: 2rem;
`;

export const HighestRpnTable: typeof Table = styled(Table)`
	.ant-table-container {
		overflow: hidden;
		border-radius: 1rem;
	}

	.ant-table-thead > tr > th {
		padding: 1rem;
		background: ${({ theme }) => theme.palette.primary[600]};
		border-bottom: none;
		color: ${({ theme }) => theme.palette.secondary.white};
		font-size: 1rem;
		font-weight: 600;
		line-height: 1.5rem;
		text-align: center;

		&::before {
			display: none;
		}
	}

	.ant-table-tbody > tr > td {
		padding: 1rem;
		background: ${({ theme }) => theme.palette.secondary[50]};
		border-bottom: 2px solid ${ROW_SEPARATOR_COLOR};
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: 1rem;
		line-height: 1.5rem;
		text-align: center;
	}

	.ant-table-tbody > tr:last-child > td {
		border-bottom: none;
	}

	.ant-table-tbody > tr.ant-table-row:hover > td {
		background: ${({ theme }) => theme.palette.secondary[50]};
	}
`;
